module.exports = __webpack_public_path__ + "static/media/hot-cat-banner-item-4.5e08c587.png";